import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const UserDown: IconDef = {
  svg: (
    <G>
      <Path
        d="M16 6.5L19 9.5M19 9.5L22 6.5M19 9.5V3.5M16 20.5V19.3C16 17.6198 16 16.7798 15.673 16.138C15.3854 15.5735 14.9265 15.1146 14.362 14.827C13.7202 14.5 12.8802 14.5 11.2 14.5H6.8C5.11984 14.5 4.27976 14.5 3.63803 14.827C3.07354 15.1146 2.6146 15.5735 2.32698 16.138C2 16.7798 2 17.6198 2 19.3V20.5M12.5 7C12.5 8.933 10.933 10.5 9 10.5C7.067 10.5 5.5 8.933 5.5 7C5.5 5.067 7.067 3.5 9 3.5C10.933 3.5 12.5 5.067 12.5 7Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  ),
  svgStyles(color) {
    return {
      stroke: color,
    };
  },
};
